import { render, staticRenderFns } from "./wgwgy.vue?vue&type=template&id=3610c1da&scoped=true&"
import script from "./wgwgy.vue?vue&type=script&lang=js&"
export * from "./wgwgy.vue?vue&type=script&lang=js&"
import style0 from "./wgwgy.vue?vue&type=style&index=0&id=3610c1da&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610c1da",
  null
  
)

export default component.exports